import { render, staticRenderFns } from "./paymentNoteDetail.vue?vue&type=template&id=51b5cc32&scoped=true"
import script from "./paymentNoteDetail.vue?vue&type=script&lang=js"
export * from "./paymentNoteDetail.vue?vue&type=script&lang=js"
import style0 from "./paymentNoteDetail.vue?vue&type=style&index=0&id=51b5cc32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b5cc32",
  null
  
)

export default component.exports